export default {
  app: {
    title: "FaceID Admin",
    welcome: "Добро пожаловать",
  },
  nav: {
    dashboard: "Главная",
    companies: "Компании",
    sessions: "Сессии",
    analytics: "Аналитика",
    funnel: "Воронка",
    verdicts: "Решения",
    performance: "Производительность",
    tenants: "Клиенты",
    sdkFunnel: "Поток SDK",
    sdkDevices: "Устройства SDK",
    uploadRejections: "Отклонённые загрузки",
    identities: "Личности",
    mobile: "Мобильное",
    mobileUsers: "Пользователи",
    mobileDevices: "Устройства",
    mobileAccessEvents: "События входа",
    mobileQrRequests: "QR-запросы",
    catalog: "Каталог",
    catalogServices: "Сервисы",
    catalogCategories: "Категории",
    apiLogs: "API логи",
    auditLogs: "Аудит логи",
    users: "Пользователи",
    settings: "Настройки",
  },
  auth: {
    loginTitle: "Вход",
    email: "Email",
    password: "Пароль",
    totpCode: "2FA код",
    loginBtn: "Войти",
    logout: "Выйти",
    invalidCredentials: "Неверный email или пароль",
    needTotp: "Требуется TOTP код",
  },
  dashboard: {
    title: "Обзор",
    todaySessions: "Сессий сегодня",
    totalSessions: "Всего сессий",
    successRate: "Уровень успеха",
    abandonRate: "Брошенные",
    activeCompanies: "Активные компании",
    avgResponseTime: "Среднее время ответа",
    recentActivity: "Недавняя активность",
    weeklyChart: "Сессии — последние 7 дней",
    passed: "Успешно",
    failed: "Неуспешно",
    abandoned: "Без решения",
    ofTerminal: "{passed} из {terminal} завершённых",
    ofAllSessions: "{pct} от всех {total} сессий",
    noVerdict: "{n} сессий не дошли до решения",
    outcomeMix: "Чем закончились сессии — последние 7 дней",
    outcomeMixHint:
      "Все сессии окна по их текущему статусу, поэтому сегменты покрывают каждую. «Истекло» — это подметённая корзина, и в ней два разных случая: фото так и не пришло, и фото пришло, было отклонено, а человек не вернулся. Чтобы их различить, нужен счётчик попыток, которого в этой сводке нет — Воронка считает это разделение по самим попыткам.",
    mix: {
      passed: "Успешно",
      failed: "Отклонено",
      inProgress: "Фото отправлено, решения нет",
      pending: "Фото ещё не отправлено",
      expired: "Истекло без решения",
      cancelled: "Отменено",
      other: "Другой статус",
    },
  },
  analytics: {
    funnelTitle: "Воронка — где теряем",
    verdictsTitle: "Решения — на чём они основаны",
    sessionFunnel: "Воронка сессий",
    gateFunnel: "По проверкам (попытки)",
    abandonment: "Типы незавершения",
    abandonmentHint: "Разница ровно в одном: поступило фото или нет. В первом случае SDK открыли, но ничего не отправили — это проблема SDK/UX. Во втором фото пришло, было отклонено, и человек больше не вернулся. Третье — единственный настоящий отказ: израсходованы все попытки.",
    retryCurve: "Успех по номеру попытки",
    retryHint: "Помогает ли повтор? Сессия хранит только последнее решение, поэтому таблица читается из строк попыток.",
    stages: {
      created: "Сессия создана",
      frames_submitted: "Кадры отправлены",
      verdict_reached: "Дошла до решения",
      passed: "Успешно",
    },
    abandon: {
      neverStarted: "Фото вообще не поступало",
      gaveUp: "Фото пришло, отклонено — не вернулись",
      exhausted: "Все попытки израсходованы",
    },
    gates: {
      detection: "Детекция лица",
      liveness: "Живость (пассивная)",
      challenge: "Challenge",
      deepfake: "Deepfake",
      match: "Сравнение",
    },
    gate: "Проверка",
    reached: "Дошло",
    gatePassed: "Прошло",
    gateRejected: "Отклонено",
    gateSkipped: "Не выполнялась",
    rejectionRate: "Доля отказов",
    attemptNo: "Попытка",
    attempts: "Всего",
    passed: "Успешно",
    notPassed: "Не прошло",
    passRate: "Успешность",
    noAttemptsTitle: "Нет данных по попыткам",
    noAttemptsHint: "Таблица attempts заполняется только после миграции 0016. Ноль означает «ещё не записано», а не «никто не отклонён».",
    ofTotal: "{pct} от общего",
    lostHere: "здесь потеряно {n} ({pct})",
    similarityTitle: "Распределение схожести",
    livenessTitle: "Живость — composite балл",
    livenessMedianTitle: "Живость — медиана (порог здесь)",
    livenessMedianHint: "Порог {gate} применяется именно к медиане. Только попытки, где эта проверка выполнялась, разделённые по её собственному решению.",
    livenessCompositeHint: "Это смешанный балл, сохраняемый в сессии (0.55·медиана + 0.30·мин + 0.15·дисперсия). К нему не применяется никакой порог — поэтому здесь нет линии.",
    noAttemptScores: "Баллы попыток ещё не записаны",
    noAttemptScoresHint: "Медиана читается из attempts.scores — заполняется после миграции 0016.",
    candidateThreshold: "Предлагаемый порог",
    thresholdMark: "Текущий",
    candidateMark: "Предложение",
    thresholdScope: "Слайдер пересчитывает только решение о СРАВНЕНИИ. Сессии, отклонённые раньше (spoof, challenge, нет госфото), схожести не дали — снижение порога их не спасёт.",
    scoredSessions: "Сессий со схожестью",
    currentlyPassed: "Сейчас прошло",
    wouldPass: "При новом пороге",
    netChange: "Чистое изменение",
    nearThreshold: "{n} сессий в пределах ±{band} от порога",
    nearThresholdHint: "Именно у них решение перевернётся от одного шага порога.",
    thresholdDrift: "В выборке несколько порогов — сессии судились по разным правилам",
    medianGate: "Медианный порог",
    failuresOverTime: "Причины отказов по времени",
    spoofBasis: "На чём основано решение spoof",
    spoofSamples: "Количество отказов",
    spoofMedian: "Средняя медиана",
    spoofRange: "Диапазон медианы",
    spoofVariance: "Средняя дисперсия",
    spoofFrames: "Среднее число кадров",
    required: "требуется",
    noSpoofData: "Нет деталей spoof",
    noSpoofDataHint: "Эти числа читаются из attempts.failure_details — они пишутся после миграции 0016.",
    noScores: "Нет сессий со скорами",
    groupedNote: "Столбцы объединены по ширине {width}",
    dateFrom: "Начало",
    dateTo: "Конец",
    percentilesApprox: "p-значения в этой панели оценены по часовым гистограммам, поэтому каждое точно лишь до ширины того интервала задержки, в который попало (отмечено ≈). Значение {cap} и выше показывается как нижняя граница — дальше гистограмма не различает.",
    reset: "Сбросить",
  },
  forensics: {
    title: "Разбор сессии",
    backToList: "К сессиям",
    attempt: "Попытка {n}",
    frames: "{n} кадров",
    afterGap: "через {s} с после предыдущей",
    gateTable: "Проверки — что измерено, что требовалось",
    timings: "Время по этапам",
    frameStrip: "Кадры",
    noFrameData: "Для этой попытки нет диагностики кадров",
    noAttempts: "Записей о попытках нет",
    noAttemptsHint: "Сессия завершилась до того, как таблица attempts начала заполняться (миграция 0016), либо кадры не отправлялись.",
    imagesGone: "Изображения сохраняются только для последней попытки — каждая отправка перезаписывает их. Числа при этом полные для каждой попытки.",
    imagesMismatch: "Число сохранённых изображений не совпадает с числом кадров этой попытки — они принадлежат предыдущей, поэтому не показаны.",
    indeterminate: "Сохранённое значение слишком близко к порогу — из-за округления эта строка не разрешима",
    noFace: "нет лица",
    multiFace: "несколько лиц",
    thresholdFromConfig: "Взято из текущей конфигурации — могло измениться после попытки",
    thresholdFromSession: "Зафиксировано при создании сессии — именно это значение судило попытку",
    configLabel: "конфиг",
    sessionLabel: "точно",
    byPinfl: "Другие сессии этого ПИНФЛ",
    byIp: "Другие сессии с этого IP",
    openShort: "Открыть",
    criteria: {
      median: "медиана",
      minimum: "минимум (усечённый)",
      variance: "дисперсия",
      samples: "число кадров",
      similarity: "схожесть",
      deepfake: "deepfake",
      frames_with_face: "кадров с лицом",
      frames_with_multiple_faces: "кадров с неск. лицами",
    },
    state: {
      passed: "пройдена",
      rejected: "отклонена",
      not_run: "не выполнялась",
    },
  },
  perf: {
    scopedHeadroom: "Внимание: фильтр активен — пик считается по выборке, а ёмкость общая. Запас здесь не означает запас у всей системы.",
    title: "Производительность — насколько быстро и сколько запаса",
    headroom: "Нагрузка и запас",
    peakMinute: "Самая нагруженная минута",
    peakRps: "Пиковая скорость",
    perSecond: "в секунду",
    capacity: "Измеренная ёмкость",
    measuredOn: "измерено {d}",
    spare: "Свободный запас",
    capacityHint: "Ёмкость — результат нагрузочного теста, а не спецификация. При изменении числа воркеров, MAX_INFLIGHT или GPU её нужно перемерить. Берётся по минуте: часовое среднее сглаживает именно тот пик, который пробивает потолок.",
    whichBackend: "Какой backend обслужил",
    backendHint: "Если GPU тихо переходит на CPU, это видно только как задержка. Поэтому — отдельная колонка. «none» — сессии, не дошедшие до анализа.",
    stageTitle: "Куда уходит время (внутри попытки)",
    stage: "Этап",
    stages: {
      signature: "Проверка подписи",
      analyze: "Анализ моделью",
      challenge: "Challenge",
      deepfake: "Deepfake",
      govt_photo: "Госфото (IMV)",
      match: "Сравнение 1:1",
    },
    samples: "Выборка",
    avg: "Среднее",
    p50: "p50",
    p95: "p95",
    p99: "p99",
    noStageData: "Тайминги этапов ещё не записаны",
    noStageDataHint: "Эти данные берутся из attempts.stage_durations — заполняются проверками после миграции 0016.",
    endpoints: "Задержки эндпоинтов",
    endpoint: "Эндпоинт",
    endpointScope: "По всему флоту — разбить по приложению нельзя: application_id в api_logs не заполняется (до Sprint 9). Без фильтра дат читаются последние 7 дней.",
    calls: "Вызовы",
    errorRate: "Доля ошибок",
    slowest: "Самые медленные сессии",
    duration: "Длительность",
  },
  tenants: {
    noErrorRate: "* Доля ошибок API не показывается: в api_logs нет привязки к приложению (до Sprint 9). Убрать колонку честнее, чем показывать фиктивные 0.0%.",
    quotaScope: "Квота всегда за текущий календарный месяц и не подчиняется фильтру дат.",
    title: "Клиенты — кто использует и как это для них работает",
    application: "Приложение",
    sessions: "Сессии",
    passRate: "Успешность",
    abandonRate: "Незавершённые",
    quota: "Квота",
    projected: "прогноз {n}",
    projectionHint: "Линейный прогноз до конца месяца: {n}. Это не предсказание, а подсказка «упрёмся ли в квоту».",
    rules: "Действующие правила",
    spoofOff: "spoof выкл",
    livenessOff: "liveness выкл",
    outlierTitle: "{n} приложений заметно ниже среднего",
    outlierBody: "{names} — среднее по флоту {mean}, порог {floor}. Такой разрыв обычно означает не модель, а интеграцию или качество кадров.",
    thresholdDrift: "Во флоте несколько порогов: {list}",
    thresholdDriftHint: "Одно и то же лицо может пройти в одном приложении и не пройти в другом. Такое уже уходило в прод незамеченным.",
    fleetNote: "Среднее по флоту {mean}, по {n} приложениям. Учитываются только приложения минимум с {min} завершёнными сессиями — малая выборка это шум, а помечать шум значит обесценить метку.",
    noFleet: "Недостаточно приложений для сравнения — ничего не помечается.",
  },
  sdk: {
    funnelTitle: "Поток SDK — где телефон их потерял",
    devicesTitle: "Устройства SDK — на чём это работало",
    platform: "Платформа",
    platforms: {
      android: "Android",
      ios: "iOS",
    },
    bundleId: "Bundle id приложения",
    sdkVersion: "Версия SDK",
    nFlows: "потоков: {n}",
    testTraffic: "Тестовый трафик",
    testTrafficHint: "Эмуляторы и debug-сборки. По умолчанию исключены — иначе внутреннее тестирование сидит внутри продакшн-чисел.",
    window: "Окно (время сервера)",
    received: "Пришло потоков",
    counted: "Учтено",
    countedHint: "На это число делятся все доли на странице",
    excluded: "Исключено",
    excludedBreakdown: "эмулятор {emulator} · debug {debuggable}",
    excludedOverlap: "Итог — не сумма двух чисел: debug-сборка на эмуляторе это одна строка, и двойной счёт сделал бы число исключённых больше множества, из которого их взяли.",
    testTrafficCounted: "Внутри тестовый трафик",
    includedOverlap: "Тестовый трафик включён в расчёт. Счётчики эмулятора и debug пересекаются — одна строка может быть и тем и другим — поэтому сложить их в общий итог нельзя.",
    clientScope: "Клиент: {id}",
    testTrafficOn: "Тестовый трафик включён",
    empty: {
      never: "Телеметрия SDK ещё ни разу не приходила",
      neverHint: "Таблица начнёт заполняться после выхода сборки Android SDK со schema_version 3. Рисовать здесь «0%» значило бы выдать неизмеренное за измеренное, поэтому панели не рисуются.",
      window: "В этом окне потоков нет",
      windowHint: "Телеметрия приходила, но не в выбранные даты. Расширьте диапазон.",
      testOnly: "Всё в этом окне было тестовым трафиком",
      testOnlyHint: "{n} потоков пришли с эмулятора или debug-сборки и исключены из продакшн-чисел. Чтобы увидеть их, включите переключатель «Тестовый трафик» выше.",
    },
    pairTitle: "Две половины: что видел телефон и что видел сервер",
    pairHint: "Сервер видит сессию только после её создания, а 54.3% сессий создаются и не получают ни одного кадра — со стороны сервера это просто тишина. Восемь стадий выше — то, что знал сам телефон; обе половины впервые стоят на одной странице.",
    clientHalf: "Сторона телефона (SDK)",
    serverHalf: "Сторона сервера (сессии)",
    serverHalfHint: "Эта половина — все сессии за тот же диапазон дат; если задан фильтр клиента, он применяется к обеим половинам. Платформы, версии SDK и bundle id в сессиях нет вовсе, поэтому они сужают только сторону телефона. Насколько половины пересекаются, считает панель связи ниже.",
    pairWaiting: "Сторона телефона пуста — SDK пока не шлёт телеметрию.",
    unstaged: "{n} потоков вне восьмёрки (REGISTRATION и QR_LOGIN — у них свои стадии). Они не добавлены в LAUNCHED: иначе вершина воронки раздувалась бы людьми, которые в неё вообще не входили.",
    stages: {
      LAUNCHED: "SDK открыт",
      SESSION_CREATED: "Сессия создана",
      CENTERING: "Центрирование лица",
      FACE_DETECTED: "Лицо найдено",
      FRAMED: "Лицо в овале",
      CHALLENGE: "Запрошен жест",
      PROCESSING: "Отправлено, ожидание",
      RESULT_SHOWN: "Результат показан",
    },
    joinTitle: "Связь с сессией",
    joinHint: "Связь — LEFT join, и должна ею остаться: потоки без сессии и есть причина, по которой таблица создавалась — отказ в доступе к камере, неудачная выдача сессии. INNER join удалил бы их молча, и в новой таблице осталось бы то же слепое пятно.",
    join: {
      matched: "Сессия найдена",
      sessionless: "Сессии не было вовсе",
      unmatched: "Id сессии есть, но не найден",
      matchedPassed: "Сервер: пройдено",
      matchedFailed: "Сервер: отказ",
      matchedOpen: "Сервер: без вердикта",
    },
    matchedHint: "Только по потокам, у которых нашлась сессия.",
    abandonTitle: "Где они ушли",
    abandonHint: "Всего брошено потоков: {n}. Долгий p90 на PROCESSING — самый чёткий признак «я решил, что оно зависло», а не медленного сервера.",
    abandonWhere: "Количество по стадиям",
    abandonHowLong: "Сколько ждали перед уходом",
    abandonedFlows: "Брошенные потоки",
    stage: "Стадия",
    ofAbandoned: "От брошенных",
    samples: "Выборка",
    samplesHint: "«Выборка» — знаменатель перцентилей, и это не число потоков: поток может записать, где остановился, но не записать, сколько простоял. Там, где не сообщил никто, стоит прочерк, а не 0.",
    errorsTitle: "Что сломалось (error_kind)",
    errorsHint: "Доля считается от всех учтённых потоков: «3% потоков умерли на разрешении камеры» — вот фраза, по которой начинают действовать.",
    errorKind: "Класс ошибки",
    ofFlows: "От потоков",
    noErrors: "Ошибок не зафиксировано",
    chartTopN: "На графике — {shown} крупнейших; в таблице все {total}.",
    errorKindsCut: "В окне было {total} различных классов ошибок, в списке — {shown} крупнейших. error_kind должен быть низкой кардинальности, поэтому само приближение к порогу — уже находка: возможно, сборка SDK генерирует имена классов.",
    retryTitle: "Повтор — видели ли они предложение?",
    retryHint: "На стороне сервера было измерено: 76% бросивших уходят после ОДНОГО отказа, имея ещё две попытки. Вторая строка здесь — доказательство, что кто-то действительно увидел предложение повторить. Столбец «Сессии» считает уникальные id: потоку без сессии некуда возвращаться.",
    attempt: "Попытка",
    attemptN: "Попытка {n}",
    noAttempts: "Строк по попыткам нет",
    flows: "Потоки",
    sessions: "Сессии",
    reachedResult: "Дошли до результата",
    abandoned: "Брошено",
    abandonRate: "Доля брошенных",
    passed: "Пройдено",
    p50: "p50",
    p90: "p90",
    p99: "p99",
    timingTitle: "Ожидание и сетевая доля в нём",
    timingHint: "processing_ms — всё время, пока крутился спиннер, то есть ожидание, которое чувствует человек. upload_ms выделяет из него сеть и необязателен даже в schema_version 3: его отсутствие значит «не сообщено», а не «0 мс». Поэтому у каждого свой счётчик выборки.",
    processing: "Обработка (спиннер)",
    upload: "Загрузка (сеть)",
    processingP50: "Обработка p50",
    processingP90: "Обработка p90",
    processingP99: "Обработка p99",
    uploadP50: "Загрузка p50",
    uploadP90: "Загрузка p90",
    cancelled: "Отменено во время обработки",
    cancelledOf: "{n} из {total}",
    nSamples: "выборка: {n}",
    noUpload: "Ни один поток не сообщил время загрузки — это не 0 мс, это отсутствие измерения.",
    byDeviceTitle: "Худшие устройства (Build.DEVICE)",
    byDeviceHint: "Build.DEVICE — кодовое имя платы: одна модель, и оно не меняется при переименованиях в маркетинге.",
    byHardwareTitle: "Худшие чипсеты (Build.HARDWARE)",
    byHardwareHint: "Build.HARDWARE — SoC, то есть целое семейство чипсетов. «Сломана одна модель» и «сломаны все телефоны на этом чипсете» — разные баги и разные владельцы.",
    device: "Устройство (DEVICE)",
    hardware: "Чипсет (HARDWARE)",
    droppedRatio: "Отброшенные кадры",
    frameSamples: "Выборка по кадрам",
    deviceModels: "Модели",
    unknownDevice: "Данных об устройстве не пришло",
    noGroups: "Ни одна группа не прошла порог в {n} потоков",
    suppressed: "Порог: минимум {min} потоков на группу. Ниже него осталось групп: {groups}, потоков: {flows} — доля по горстке событий это шум, но именно эта сумма показывает широкую проблему вида «сто моделей, каждая падает по пять раз».",
    topN: "Показано {shown} из {total}",
    droppedTitle: "Доля отброшенных кадров (по устройствам)",
    droppedHint: "Высокая доля на одной модели — неисправность камеры или перегрев. На сервере это выходит как INSUFFICIENT_FACE_FRAMES и читается как вина пользователя.",
    noFrameCounts: "Ни одна группа не сообщила счётчики кадров",
    droppedMissing: "{n} групп не сообщили счётчики кадров вовсе — у них не 0%, у них нет измерения.",
    apiLevelTitle: "По уровню API",
    apiLevelHint: "Build.VERSION.SDK_INT полезнее маркетинговой версии: поведение камеры и ML зависит именно от уровня API. На iOS такого поля нет, а на Android мог не прийти блок устройства — и то и другое не 0, а «не измерено».",
    apiLevel: "Уровень API",
    densityTitle: "Плотность экрана и выходы из овала",
    densityHint: "framing_flap_count — та самая патология «то в овале, то нет». Ровно размазанная по плотностям, это проблема подсказок; собранная в одной полосе dpi — овал свёрстан не того размера на этих экранах, то есть починяемый баг вёрстки.",
    density: "Плотность (dpi)",
    flapSamples: "Выборка по flap",
    flapSamplesHint: "Среднее и p90 считаются только по потокам, приславшим значение — поэтому рядом стоит размер выборки, а не число потоков.",
    avgFlaps: "Среднее flap",
    p90Flaps: "p90 flap",
    integratorsTitle: "Интеграторы (host-приложения)",
    integratorsHint: "Ключ — app_bundle_id, а не application_id: Application.bundle_ids пока никто не заполняет, поэтому application_id в каждой строке NULL. Bundle id присылает вызывающая сторона — он сегментирует, но не подтверждает приложение.",
    bundleUnverified: "Фильтр клиента не задан: bundle id присылает сама вызывающая сторона, поэтому любой с действительным токеном SDK может записать потоки под чужим bundle id. В таком виде эти строки — указание, а не доказательство. С фильтром по клиенту под bundle остаётся то, что действительно прислал этот клиент.",
    sdkVersions: "Версии SDK",
    versionClickHint: "Клик по тегу версии фильтрует всю страницу — устройства, экраны, тайминги — по этой сборке. А доля брошенных по версиям есть ниже, в таблице «Релизы», без всякой фильтрации.",
    releasesTitle: "Релизы — стала ли новая версия хуже?",
    releasesHint: "Каждая строка — одно приложение и одна сборка SDK; сборки стоят рядом в порядке выпуска. Последний столбец — разница с предыдущей сборкой этого же приложения из списка, в процентных пунктах: плюс значит, что новый релиз теряет больше людей. Важно: сборки, не прошедшие порог, в список не попадают, поэтому «предыдущая» — это предыдущая показанная, а не обязательно ближайшая по времени.",
    version: "Версия",
    deltaVsPrev: "К предыдущей версии",
    ppSuffix: "п.п.",
    baselineVersion: "первая сборка",
    releaseSuppressed: "Ниже порога: пар (приложение, версия) — {groups}, потоков — {flows}. Только что выкаченная версия всегда начинается отсюда, и её отсутствие не значит «ноль».",
    noReleases: "Строк по версиям для сравнения нет",
    versionsTitle: "Сравнение версий — как ведёт себя каждая сборка",
    versionsHint: "По одной строке на сборку SDK, с группировкой по платформе и без их смешивания — одна и та же строка версии встречается на обеих. Клик по версии фильтрует всю страницу по этой сборке. В отличие от таблицы релизов на странице устройств, эту можно сортировать: строки самостоятельны, ничего не сравнивается со строкой выше.",
    versionsEdgeHint: "Первый и последний день сборки внутри окна неполные, поэтому у только что выкаченной версии мало потоков — сначала смотрите на их число, потом на её доли.",
    share: "Доля",
    passRate: "Доля успешных",
    errorFlows: "Ошибки",
    topError: "Самая частая ошибка",
    firstSeen: "Впервые",
    lastSeen: "В последний раз",
    noVersions: "В этом окне нет строк по версиям",
    notMeasured: "Не измерено",
    shareHint: "От потоков этой платформы в окне, а не от всего окна: доли внутри одной платформы дают 100%. Android и iOS — две разные совокупности, и они никогда не объединяются.",
    mixedPlatforms: "Фильтр платформы пуст: Android и iOS на одной странице. Строки не смешиваются, но и сравнивать их между собой нельзя — большей части измеряемых полей на iOS просто нет.",
  },
  rejections: {
    title: "Отклонённые загрузки — что сервер не принял",
    sessionTitle: "Отклонённые загрузки",
    empty: "Отклонённых загрузок нет",
    noData: "В этом окне загрузок не было",
    loadFailed: "Не удалось загрузить отклонённые загрузки",
    time: "Время",
    status: "Статус",
    category: "Причина",
    platform: "Платформа",
    duration: "Длительность",
    uploads: "Загрузки",
    rejected: "Отклонено",
    rejectedShare: "Доля отклонённых",
    dailyTitle: "По дням — загрузки и отклонения",
    categoriesTitle: "Причины",
    platformsTitle: "По платформам",
    count: "Количество",
    share: "Доля",
    rangeHint: "Не более {n} дней",
    rangeClamped: "Окно ограничено {n} днями — начальная дата сдвинута",
    noCategory: "Причина не записана",
    httpCode: "HTTP {status}",
    endpoint: "Эндпоинт",
    sessionScope: "Отклонённые запросы с устройства — не только загрузки кадров.",
    codes: {
      FRAME_TAMPERED: "Кадр изменён",
      INVALID_TOKEN: "Неверный токен",
      INVALID_IMAGE: "Неверное изображение",
      FRAMES_TOO_MANY: "Слишком много кадров",
      FRAMES_TOO_FEW: "Слишком мало кадров",
      SESSION_EXPIRED: "Сессия истекла",
      SESSION_NOT_FOUND: "Сессия не найдена",
      ATTESTATION_FAILED: "Проверка приложения не пройдена",
      CLIENT_DISCONNECT: "Клиент оборвал загрузку",
      VALIDATION_ERROR: "Неверный формат запроса",
    },
    details: {
      body_hash: "Хеш тела запроса не совпадает",
      clock_skew: "Часы устройства неверны",
      hmac_mismatch: "Подпись не совпадает",
      missing_bearer: "Токен не передан",
      not_sdk_token: "Это не SDK-токен",
      wrong_session: "Токен другой сессии",
      bad_subject: "Субъект токена не сессия",
      unknown_session: "Сессия из токена не найдена",
      bad_payload_json: "Некорректный JSON",
      frame_too_large: "Кадр слишком большой",
      total_too_large: "Общий размер слишком большой",
      part_too_large: "Часть снимка слишком большая",
      metadata_too_large: "Метаданные слишком большие",
      too_many: "Слишком много кадров",
      missing_proof: "У кадра нет proof",
      too_few: "Слишком мало кадров",
      too_many_files: "Слишком много файлов",
      bad_metadata_json: "Некорректный JSON метаданных",
      metadata_too_deep: "Слишком глубокая вложенность метаданных",
      missing_flash_id: "Отсутствует flash id",
      not_jpeg: "Не JPEG",
      body_read: "Загрузка прервалась на середине",
      no_route: "Такого маршрута нет",
    },
    platforms: {
      android: "Android",
      ios: "iOS",
      web: "Веб",
      other: "Другое",
    },
  },
  companies: {
    title: "Компании",
    create: "Новая компания",
    name: "Название",
    slug: "Slug",
    slugHint: "a-z, 0-9, -",
    inn: "ИНН",
    email: "Email",
    phone: "Телефон",
    address: "Адрес",
    status: "Статус",
    createdAt: "Создано",
    actions: "Действия",
    edit: "Редактировать",
    suspend: "Приостановить",
    activate: "Активировать",
    detail: "Подробности",
    applications: "Приложения",
    statusActive: "активна",
    statusSuspended: "приостановлена",
    statusPending: "ожидает подтверждения",
    createSuccess: "Компания создана",
    updateSuccess: "Компания обновлена",
  },
  sessions: {
    title: "Сессии",
    id: "ID сессии",
    method: "Метод",
    status: "Статус",
    statusHint:
      "Подпись строится по числу попыток, а не по слову статуса: 0 попыток — фото не поступало, 1 и больше — фото пришло и было отклонено. Наведите курсор, чтобы увидеть сырой статус.",
    outcome: {
      passed: "Пройдено",
      failed: "Отклонено",
      cancelled: "Отменено",
      awaitingPhoto: "Ожидается фото",
      retrying: "Фото пришло, повторная попытка",
      expiredNoPhoto: "Истёк — фото не поступало",
      expiredAbandoned: "Истёк — брошено после отказа",
    },
    pinfl: "ПИНФЛ",
    similarity: "Схожесть",
    liveness: "Живость",
    quality: "Качество",
    attempts: "Попытки",
    failureReason: "Причина ошибки",
    createdAt: "Создано",
    completedAt: "Завершено",
    ip: "IP адрес",
    detail: "Детали сессии",
    company: "Компания",
    application: "Приложение",
    origin: "Источник",
    threshold: "Порог",
    mlBackend: "ML backend",
    mlBackendNone: "Без анализа",
    duration: "Длительность",
    unmanaged: "Без приложения",
    thresholdDiffers: "Отличается от большинства строк на этой странице",
    thresholdDrift: "В этом фильтре использовано разных порогов: {count}",
    thresholdDriftHint: "По всему фильтру, независимо от текущей страницы",
    allStatuses: "Все статусы",
    allMethods: "Все методы",
    allCompanies: "Все компании",
    allApplications: "Все приложения",
    allOrigins: "Все источники",
    allFailureReasons: "Все причины ошибок",
    allBackends: "Все backend'ы",
    origin_sdk: "SDK",
    origin_app_login: "Вход в приложение",
    origin_qr_login: "Вход по QR",
    dateRange: "Период",
    searchPlaceholder: "Поиск по ПИНФЛ",
    resetFilters: "Сбросить фильтры",
    clientScope: "Клиент: {id}",
    statsTotal: "Всего",
    statsPassed: "Успешно",
    statsFailed: "Неуспешно",
    passRate: "Уровень успеха",
    passRateHint:
      "Только завершённые сессии: успешные / (успешные + неуспешные)",
    avgSimilarity: "Средняя схожесть",
    avgLiveness: "Средняя живость",
    avgDuration: "Средняя длительность",
    empty: "Сессии не найдены",
    forbidden: "Нет доступа к этим данным",
    photos: "Фото",
    govtPhoto: "Фото паспорта",
    registryPassportPhoto: "Фото паспорта (Личности)",
    selfie: "Селфи",
    frames: "Кадры",
    noPhotos: "Для этой сессии нет фото",
  },
  // Проверки безопасности приложения — одни и те же слова в таблице
  // приложений и в таблице сессий.
  challenges: {
    head_yaw_left: "Поворот влево",
    head_yaw_right: "Поворот вправо",
    head_pitch_up: "Наклон вверх",
    head_pitch_down: "Наклон вниз",
  },
  checks: {
    title: "Проверки",
    spoof: "Проверка на спуфинг",
    liveness: "Проверка живости",
    frameTime: "Проверка времени кадра",
    appAttest: "Проверка iOS App Attest",
    stateOn: "включена",
    stateOff: "выключена",
    disabled: "Проверка выключена",
    disabledHint: "Выключено: {checks}",
    disabledHintSession: "Выключено в этой сессии: {checks}",
    superAdminOnly: "Менять проверки может только супер-админ",
  },
  identities: {
    title: "Подтверждённые личности",
    searchPlaceholder: "Поиск по ПИНФЛ или имени",
    pinfl: "ПИНФЛ",
    fullName: "Ф.И.О.",
    firstName: "Имя",
    lastName: "Фамилия",
    middleName: "Отчество",
    passport: "Паспорт",
    birthDate: "Дата рождения",
    verificationCount: "Верификаций",
    lastVerifiedAt: "Последняя верификация",
    createdAt: "Создано",
    updatedAt: "Обновлено",
    images: "Изображения",
    passportImage: "Фото паспорта",
    verificationImage: "Кадр верификации",
    noImage: "Нет изображения",
    detail: "Детали личности",
    empty: "Подтверждённых личностей пока нет",
    delete: "Удалить личность",
    deleteConfirm:
      "Удалить личность {pinfl} без возможности восстановления? Запись И оба файла изображений будут стёрты.",
    deleteSuccess: "Личность удалена",
    forbidden: "Страница доступна только супер-администраторам",
    alternativeImage: "Альтернативное изображение",
    alternativeHint:
      "Когда задано альтернативное изображение, лицо этого человека сверяется с ним, а не с фото паспорта. Используйте, если фото паспорта больше на него не похоже.",
    alternativeDropHint: "Перетащите изображение сюда или нажмите для выбора",
    alternativeConstraints: "JPEG, PNG или WebP — одно лицо, до 10 МБ",
    alternativeRemove: "Удалить изображение",
    alternativeRemoveTitle: "Удаление альтернативного изображения",
    alternativeRemoveConfirm:
      "Удалить альтернативное изображение личности {pinfl}? Сверка для этого человека вернётся к фото паспорта.",
    alternativeUploadSuccess: "Альтернативное изображение сохранено",
    alternativeRemoveSuccess: "Альтернативное изображение удалено",
    alternativeTypeRejected:
      "Принимаются только изображения JPEG, PNG или WebP",
    alternativeTooLarge: "Размер изображения не должен превышать 10 МБ",
    alternativeHistory: "История изменений",
    alternativeHistoryEmpty: "Изменений пока нет",
    alternativeHistoryWhen: "Дата / время",
    alternativeHistoryActor: "Администратор",
    alternativeHistoryAction: "Действие",
    alternativeAction_uploaded: "Загружено",
    alternativeAction_removed: "Удалено",
    alternativeErrNoFace:
      "На изображении не найдено лицо — выберите фото с одним хорошо видимым лицом",
    alternativeErrMultipleFaces:
      "На изображении больше одного лица — выберите фото ровно с одним",
    alternativeErrInvalidImage:
      "Файл не является пригодным изображением: не читается или размер вне допустимых границ",
    alternativeErrIdentityNotFound: "Этой личности больше не существует",
    alternativeErrNotFound: "У этой личности нет альтернативного изображения",
  },
  mobile: {
    usersTitle: "Пользователи мобильного приложения",
    usersSearchPlaceholder: "ПИНФЛ, имя или телефон",
    usersEmpty: "Пользователей пока нет",
    devicesTitle: "Мобильные устройства",
    devicesSearchPlaceholder: "ID устройства, модель или владелец",
    devicesEmpty: "Устройств нет",
    eventsTitle: "События входа",
    eventsEmpty: "Событий нет",
    qrTitle: "QR-запросы",
    qrEmpty: "QR-запросов нет",
    pinfl: "ПИНФЛ",
    fullName: "Ф.И.О.",
    firstName: "Имя",
    lastName: "Фамилия",
    middleName: "Отчество",
    passport: "Паспорт",
    birthDate: "Дата рождения",
    phone: "Телефон",
    status: "Статус",
    allStatuses: "Все статусы",
    status_active: "активен",
    status_suspended: "приостановлен",
    status_deleted: "удалён",
    status_revoked: "отозвано",
    status_pending: "ожидает",
    status_scanned: "отсканирован",
    status_approved: "подтверждён",
    status_rejected: "отклонён",
    status_expired: "истёк",
    status_consumed: "использован",
    deviceCount: "Устройства (всего)",
    loginCount: "События",
    lastLogin: "Последний вход",
    lastEventAt: "Последнее событие",
    createdAt: "Создано",
    updatedAt: "Обновлено",
    language: "Язык",
    userDetail: "Детали пользователя",
    tabProfile: "Профиль",
    tabDevices: "Устройства",
    tabHistory: "История",
    photo: "Зарегистрированное фото",
    noPhoto: "Нет изображения",
    owner: "Владелец",
    platform: "Платформа",
    allPlatforms: "Все платформы",
    platform_ios: "iOS",
    platform_android: "Android",
    model: "Модель",
    osVersion: "Версия ОС",
    deviceUid: "ID устройства",
    lastSeen: "Последняя активность",
    revoke: "Отозвать",
    revokeDevice: "Отозвать устройство",
    revokeConfirm:
      "Отозвать устройство {device}? Оно сразу выйдет из системы и должно будет зарегистрироваться заново.",
    revokeSuccess: "Устройство отозвано",
    suspend: "Приостановить",
    activate: "Активировать",
    suspendConfirm:
      "Приостановить пользователя {pinfl}? Он сразу выйдет из системы на всех устройствах.",
    activateConfirm: "Снова активировать пользователя {pinfl}?",
    suspendSuccess: "Пользователь приостановлен",
    activateSuccess: "Пользователь активирован",
    time: "Время",
    eventType: "Тип события",
    allEventTypes: "Все типы",
    event_app_login: "Вход в приложение",
    event_qr_login: "Вход по QR",
    result: "Результат",
    allResults: "Все результаты",
    result_approved: "подтверждён",
    result_rejected: "отклонён",
    result_failed: "ошибка",
    systemName: "Система",
    similarity: "Схожесть",
    liveness: "Живость",
    ip: "IP адрес",
    dateFrom: "Начало",
    dateTo: "Конец",
    scopes: "Запрошенные права",
    scannedAt: "Отсканирован",
    completedAt: "Завершён",
    expiresAt: "Истекает",
    statsTitle: "Мобильное приложение",
    totalUsers: "Всего пользователей",
    activeDevices: "Активные устройства",
    loginsToday: "Входов сегодня",
    qrApprovalsToday: "QR-подтверждений сегодня",
    forbidden: "Страница доступна только супер-администраторам",
  },
  catalog: {
    servicesTitle: "Каталог сервисов",
    servicesEmpty: "Сервисы не найдены",
    searchPlaceholder: "Поиск по названию",
    createService: "Новый сервис",
    editService: "Редактировать сервис",
    logo: "Логотип",
    logoUrl: "URL логотипа",
    logoDropHint: "Перетащите файл сюда или нажмите для выбора",
    logoConstraints: "PNG, JPEG или WEBP · до 2 МБ · уменьшается до 512×512",
    logoTypeRejected: "Загрузить можно только изображения PNG, JPEG или WEBP",
    logoTooLarge: "Размер файла не должен превышать 2 МБ",
    logoUploadSuccess: "Логотип загружен",
    logoFromUpload: "Загруженный файл",
    logoFromUrl: "Внешний URL",
    logoRemove: "Удалить логотип",
    logoUseUrl: "или введите URL",
    name: "Название",
    category: "Категория",
    allCategories: "Все категории",
    type: "Тип",
    allTypes: "Все типы",
    type_web: "Веб-страница",
    type_mobile: "Мобильное приложение",
    link: "Ссылка",
    link_ios: "iOS",
    link_android: "Android",
    link_deeplink: "Deeplink",
    noLink: "Нет ссылки",
    url: "URL веб-страницы",
    urlRequired: "Для веб-страницы URL обязателен",
    invalidUrl: "URL должен начинаться с http:// или https://",
    iosUrl: "Ссылка iOS (App Store)",
    androidUrl: "Ссылка Android (Google Play)",
    deeplink: "Deeplink",
    mobileLinksHint:
      "Заполните хотя бы одно: iOS, Android или deeplink — иначе приложение не сможет открыть карточку.",
    mobileLinkRequired:
      "Нужна хотя бы одна ссылка: iOS, Android или deeplink",
    company: "Компания",
    companyPlaceholder: "Необязательно",
    order: "Порядок",
    orderHint: "Меньше число — выше в списке",
    active: "Активен",
    allStatuses: "Все статусы",
    statusActive: "Активные",
    statusInactive: "Неактивные",
    resetFilters: "Сбросить фильтры",
    noCategories: "Сначала создайте категорию — без неё сервис не сохранить.",
    createServiceSuccess: "Сервис создан",
    updateServiceSuccess: "Сервис обновлён",
    deleteService: "Удалить сервис",
    deleteServiceConfirm:
      "Удалить сервис {name}? Он исчезнет из мобильного приложения.",
    deleteServiceSuccess: "Сервис удалён",
    categoriesTitle: "Категории сервисов",
    categoriesEmpty: "Категорий нет",
    createCategory: "Новая категория",
    editCategory: "Редактировать категорию",
    key: "Ключ",
    keyHint: "a-z, 0-9, -, _",
    keyInvalid: "Ключ: a-z, 0-9, - и _, 2–64 символа",
    keyImmutable: "Ключ нельзя изменить после создания",
    nameUz: "Название (uz)",
    nameRu: "Название (ru)",
    nameEn: "Название (en)",
    createCategorySuccess: "Категория создана",
    updateCategorySuccess: "Категория обновлена",
    deleteCategory: "Удалить категорию",
    deleteCategoryConfirm: "Удалить категорию {name}?",
    deleteCategorySuccess: "Категория удалена",
    deleteCategoryBlocked: "Категорию не удалось удалить",
    categoryInUseHint:
      "Сначала перенесите сервисы этой категории в другую или удалите их.",
    forbidden: "Нет прав на изменение этих данных",
  },
  apiLogs: {
    title: "API логи",
    endpoint: "Endpoint",
    method: "Метод",
    statusCode: "Статус",
    duration: "Длительность",
    success: "Результат",
    errorCode: "Код ошибки",
    ip: "IP адрес",
    cached: "Кеш",
    timestamp: "Время",
    allCodes: "Все коды",
    onlySuccess: "Только успешные",
    onlyFailed: "Только ошибки",
  },
  auditLogs: {
    title: "Аудит логи",
    eventType: "Тип события",
    actorType: "Актор",
    actorId: "ID актора",
    ip: "IP адрес",
    payload: "Данные",
    createdAt: "Время",
    allEvents: "Все события",
    allActors: "Все акторы",
    view: "Просмотр",
    detail: "Запись аудита",
  },
  members: {
    title: "Сотрудники",
    invite: "Пригласить сотрудника",
    email: "Email",
    role: "Роль",
    fullName: "Полное имя",
    createdAt: "Добавлен",
    roleOwner: "Владелец",
    roleAdmin: "Админ",
    roleViewer: "Наблюдатель",
    roleHint:
      "Сейчас все три дают одно и то же: данные этой компании, только чтение. Роль сохраняется на будущее.",
    changeRole: "Изменить роль",
    remove: "Удалить",
    removeConfirm: "Удалить сотрудника?",
    inviteSuccess: "Сотрудник добавлен",
    roleSuccess: "Роль изменена",
    removeSuccess: "Сотрудник удалён",
    tempPasswordWarning: "Создан новый пользователь. Этот пароль показан только СЕЙЧАС!",
    tempPassword: "Временный пароль",
  },
  applications: {
    title: "Приложения",
    create: "Новое приложение",
    name: "Название",
    slug: "Slug",
    clientId: "client_id",
    clientSecret: "client_secret",
    webhookSecret: "Webhook-секрет",
    webhookSecretHint:
      "HMAC-ключ для проверки заголовка X-FaceID-Signature в вебхуках.",
    rotateWebhookSecret: "Сменить секрет",
    rotateConfirm:
      "Сменить webhook-секрет этого приложения? Старый секрет сразу перестанет работать.",
    webhookSecretRotated: "Новый webhook-секрет",
    rotateClientSecret: "Новый client_secret",
    rotateClientConfirm:
      "Сменить client_secret этого приложения? Старый секрет сразу перестанет работать; client_id не меняется.",
    clientSecretRotated: "Новый client_secret",
    clientSecretHint:
      "Используйте его в OAuth-запросе access-token. client_id не изменился.",
    quota: "Месячная квота",
    webhook: "Webhook URL",
    isWeb: "Web",
    isMobile: "Мобильное",
    secretWarning: "Этот секрет показан только СЕЙЧАС. Сохраните его!",
    secretCopied: "Скопировано",
    threshold: "Схожесть",
    thresholdEdit: "Порог схожести",
    thresholdHint:
      "Минимальный балл совпадения лиц для прохождения проверки (0.55–0.99). Выше — строже. По умолчанию 0.65.",
    securityTitle: "Настройки безопасности приложения",
    securitySuccess: "Настройки приложения сохранены",
    noChanges: "Изменений нет",
    checkSpoofHint:
      "Пассивная модель анти-спуфинга и проверка на дипфейк/экран. Выключено: распечатанное фото или экран телефона больше не отклоняются.",
    checkLivenessHint:
      "Активные задания с поворотом головы. Выключено: SDK получает ПУСТОЙ список challenges — пользователя никогда не просят повернуть голову.",
    checkFrameTimeHint:
      "Каждый кадр подписывается устройством и по часам САМОГО УСТРОЙСТВА должен отличаться от времени сервера не более чем на 5 минут — в любую сторону. Включено: пользователь, у которого на телефоне или компьютере неверная дата или время, всегда отклоняется как подделавший кадр, и повторные попытки не помогают. Выключено: кадры по-прежнему подписываются и проверяются криптографически, не проверяется только 5-минутное окно — выключайте для устройств, часы которых нельзя исправить.",
    checkAppAttestHint:
      "Apple App Attest для кадров с iOS: Apple подтверждает, что запрос пришёл из подлинной, неизменённой копии приложения на реальном устройстве Apple. Выключено: кадр с iOS из перепакованного приложения, симулятора или скрипта больше не отклоняется. На Android и web это не влияет.",
    challengeTypes: "Задания на движение головой",
    challengeTypesHint:
      "Каждой сессии случайно выдаются 2 из отмеченных. Замер на проде: наклоны вверх/вниз проваливаются в 3.2 раза чаще поворотов (33.5% и 30.6% против 10.3% и 9.8%) — телефон держат на уровне груди, и голова естественно наклонена вниз.",
    challengeTypesMin:
      "Нужно отметить минимум 2. Чтобы отключить проверку полностью, используйте переключатель «Живость» выше.",
    iosAppIds: "iOS App ID",
    iosAppIdAdd: "Добавить",
    iosAppIdPlaceholder: "ABCDE12345.uz.company.app",
    iosAppIdsHint:
      "Какие Apple App ID могут проходить аттестацию для этого приложения — наш SDK встроен в несколько приложений, у каждого свой. Формат: Team ID из 10 символов, точка, затем bundle id (Team ID сохраняется в верхнем регистре, bundle id — как введён). Не более 20. Пустой список означает, что используется App ID по умолчанию на сервере.",
    iosAppIdsEmpty: "Списка нет — используется App ID по умолчанию на сервере.",
    iosAppIdInvalid:
      "Формат должен быть TEAMID.bundle.id — Team ID из 10 символов (A–Z, 0–9), точка, затем bundle id. Например: ABCDE12345.uz.company.app.",
    iosAppIdDuplicate: "Этот App ID уже в списке",
    iosAppIdTooLong: "App ID не длиннее 255 символов",
    iosAppIdLimit: "Не более 20 App ID",
    checkOffTitle: "Уровень безопасности понижается",
    checkOffConfirmButton: "Да, выключить",
    checkSpoofOffConfirm:
      "Выключить проверку на спуфинг? После этого распечатанное фото или изображение с экрана телефона тоже пройдут проверку.",
    checkLivenessOffConfirm:
      "Выключить проверку живости? Пользователя не попросят повернуть голову, то есть присутствие живого человека не проверяется.",
    checkFrameTimeOffConfirm:
      "Выключить проверку времени кадра? Кадры останутся подписанными и криптографически проверяемыми, но кадр будет приниматься и спустя долгое время после съёмки — то есть записанные кадры можно будет повторно отправить в ту же сессию, пока она не истекла (10 минут). Кадры другой сессии по-прежнему отклоняются.",
    checkAppAttestOffConfirm:
      "Выключить проверку App Attest? После этого кадр с iOS принимается без подтверждения Apple — значит, перепакованная копия вашего приложения, симулятор или скрипт тоже смогут отправлять кадры.",
    createSuccess: "Приложение создано",
    credentials: "Учётные данные",
    shareLink: "Ссылка для передачи",
    shareConfirm:
      "Создать одноразовую ссылку? Это сменит client_secret И webhook_secret и сделает недействительной прежнюю ссылку.",
    shareTitle: "Одноразовая ссылка с ключами",
    shareHint:
      "Получатель сможет открыть ссылку и увидеть ключи только один раз. Создание новой ссылки сделает эту недействительной.",
    shareUrl: "Ссылка",
    shareExpires: "Истекает",
  },
  users: {
    title: "Пользователи бэкофиса",
    create: "Новый пользователь",
    edit: "Изменить",
    email: "Email",
    invalidEmail: "Неверный email",
    password: "Пароль",
    newPassword: "Новый пароль",
    passwordMin: "Минимум 8 символов",
    changePassword: "Сменить пароль",
    fullName: "Ф.И.О.",
    role: "Роль",
    role_super_admin: "Супер-админ",
    role_moderator: "Модератор",
    role_bookkeeping: "Бухгалтерия",
    role_support: "Поддержка",
    role_readonly: "Только чтение",
    role_company_viewer: "Компания (только просмотр)",
    active: "Активен",
    activeYes: "Активен",
    activeNo: "Отключён",
    lastLogin: "Последний вход",
    you: "вы",
    delete: "Удалить пользователя",
    deleteConfirm: "Удалить {email}? Доступ будет закрыт сразу.",
    createSuccess: "Пользователь создан",
    updateSuccess: "Пользователь обновлён",
    deleteSuccess: "Пользователь удалён",
    passwordSuccess: "Пароль изменён",
  },
  common: {
    save: "Сохранить",
    cancel: "Отмена",
    confirm: "Подтвердить",
    close: "Закрыть",
    delete: "Удалить",
    search: "Поиск",
    refresh: "Обновить",
    exportCsv: "Экспорт CSV",
    loading: "Загрузка...",
    empty: "Нет данных",
    requiredField: "Обязательное поле",
    yes: "Да",
    no: "Нет",
    locale: "Язык",
    loadFailed: "Не удалось загрузить",
    retry: "Повторить",
    totalCapped: "Всего {n}+",
    totalCappedHint: "Сервер прекратил подсчёт на этом месте, так что это нижняя граница, а не точное число — точный подсчёт по миллионам строк дороже самой страницы. Пагинация заканчивается на этом числе: чтобы добраться до строк за ним, сужайте фильтры, а не листайте дальше.",
  },
  errors: {
    network: "Сетевая ошибка",
    serverError: "Ошибка сервера",
    notFound: "Не найдено",
  },
  share: {
    appLabel: "Приложение",
    reveal: "Показать ключи",
    revealWarning:
      "Эти ключи показываются только один раз — скопируйте и сохраните их сейчас.",
    clientId: "client_id",
    clientSecret: "client_secret",
    webhookSecret: "Webhook-секрет",
    loading: "Загрузка…",
    consumedTitle: "Уже получены",
    consumedBody:
      "Эти ключи уже были получены и не могут быть показаны снова. Попросите администратора создать новую ссылку.",
    expiredTitle: "Ссылка истекла",
    expiredBody:
      "Срок действия ссылки истёк. Попросите администратора создать новую.",
    invalidTitle: "Недействительная ссылка",
    invalidBody:
      "Эта ссылка недействительна или больше не существует. Попросите администратора создать новую.",
  },
};
